module.exports = __webpack_public_path__ + "img/1_ki.e32707db.jpg";